import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "week-calendar" };
const _hoisted_2 = { class: "week-calendar__header" };
const _hoisted_3 = { class: "week-calendar__title" };
const _hoisted_4 = { class: "week-calendar__nav" };
const _hoisted_5 = { class: "week-calendar__weeks" };
const _hoisted_6 = { class: "week-calendar__days week-calendar__days--header" };
const _hoisted_7 = { class: "week-calendar__day" };
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "week-calendar__events" };
const _hoisted_10 = { class: "week-calendar__event-title" };
const _hoisted_11 = {
    key: 0,
    class: "week-calendar__event-details"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "week-calendar__event-title" };
const _hoisted_14 = {
    key: 0,
    class: "week-calendar__event-details"
};
const _hoisted_15 = {
    key: 0,
    class: "week-calendar__no-events"
};
const _hoisted_16 = { class: "week-calendar__no-events-message" };
import { ref, watch } from 'vue';
import moment from "moment";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WeekCalendar',
    props: {
        events: {},
        date: {},
        now: {},
        minDate: {},
        maxDate: {},
        numberOfWeeks: {},
        noEventsMessage: {},
        noHighlightNow: { type: Boolean }
    },
    emits: [
        'change',
        'select-event'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const from = ref(initialStartDate());
        const until = ref(calculateUntilDate());
        const hasPrev = ref(true);
        const hasNext = ref(true);
        const weeks = ref([]);
        const visibleEvents = ref([]);
        init();
        watch(() => props.date, () => {
            from.value = initialStartDate();
            init();
        });
        watch(() => props.events, init);
        function init() {
            until.value = calculateUntilDate();
            weeks.value = [];
            for (let i = 0; i < (props.numberOfWeeks ?? 1); i++) {
                weeks.value.push(createWeek(i));
            }
            visibleEvents.value = [];
            weeks.value.forEach(week => {
                week.days.forEach(day => {
                    day.events.forEach(event => visibleEvents.value.push(event));
                });
            });
            hasPrev.value = props.minDate === undefined || from.value.getTime() > props.minDate.getTime();
            hasNext.value = props.maxDate === undefined || getNext().getTime() < props.maxDate.getTime();
        }
        function createWeek(weekNumber) {
            const days = [];
            for (let i = 0; i < 7; i++) {
                days.push(createDay((weekNumber * 7) + i));
            }
            const date = moment(from.value).add(weekNumber, 'weeks');
            return {
                year: parseInt(date.format('YYYY')),
                weekOfYear: parseInt(date.format('w')),
                days: days,
            };
        }
        function createDay(dayNumber) {
            const now = moment(props.now ?? new Date());
            const date = moment(from.value).add(dayNumber, 'days');
            const number = date.format('d');
            const events = props.events
                .filter(event => {
                return moment(event.date).isSame(date, 'day');
            })
                .map(event => {
                if (!event.classes) {
                    event.classes = [];
                }
                event.classes.push('week-calendar__event--status-' + event.status || 'default');
                return event;
            });
            const classes = {
                'week-calendar__day': true,
                'week-calendar__day--active': !props.noHighlightNow && date.isSame(moment(props.now ?? new Date()), 'day'),
                'week-calendar__day--has-events': events.length > 0,
                'week-calendar__day--no-events': events.length === 0,
                'week-calendar__day--past': date.isBefore(now.startOf('day')),
                'week-calendar__day--today': date.isSame(now, 'day'),
                'week-calendar__day--future': date.isAfter(now.endOf('day')),
            };
            classes['week-calendar__day--' + number] = true;
            const format = dayNumber === 0 || !date.isSame(date.clone().subtract(1, 'day'), 'month')
                ? 'D. MMM'
                : 'D.';
            return {
                number: number,
                name: date.format(format),
                date: date.toDate(),
                events: events,
                active: false,
                classes: classes
            };
        }
        function prev() {
            if (!hasPrev.value) {
                return;
            }
            from.value = getPrev();
            onChange();
        }
        function next() {
            if (!hasNext.value) {
                return;
            }
            from.value = getNext();
            onChange();
        }
        function reset() {
            from.value = initialStartDate();
            onChange();
        }
        function initialStartDate() {
            const start = moment(props.date ?? new Date()).startOf('week');
            return start.toDate();
        }
        function calculateUntilDate() {
            return moment(from.value)
                .add((7 * (props.numberOfWeeks ?? 1)) - 1, 'days')
                .endOf('day')
                .toDate();
        }
        function onChange() {
            init();
            emit('change', from.value, until.value);
        }
        function selectEvent(event) {
            emit('select-event', event);
        }
        function getPrev() {
            return moment(from.value).subtract(props.numberOfWeeks ?? 1, 'weeks').toDate();
        }
        function getNext() {
            return moment(from.value).add(props.numberOfWeeks ?? 1, 'weeks').toDate();
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "title", {}, () => [
                            _createTextVNode(_toDisplayString(_ctx.$t('week.from_until', [_ctx.$date(from.value, from.value.getFullYear() === until.value.getFullYear()
                                    ? (from.value.getMonth() === until.value.getMonth()
                                        ? 'Do' : 'Do MMMM') : 'Do MMMM YYYY'), _ctx.$date(until.value, 'Do MMMM YYYY')])), 1)
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        (hasPrev.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "week-calendar__nav-link",
                                onClick: _withModifiers(prev, ["prevent"]),
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "angle-left" })
                            ]))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (hasPrev.value || hasNext.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "week-calendar__nav-link week-calendar__nav-link--reset",
                                onClick: _withModifiers(reset, ["prevent"]),
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "dot-circle" })
                            ]))
                            : _createCommentVNode("", true),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (hasNext.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                class: "week-calendar__nav-link",
                                onClick: _withModifiers(next, ["prevent"]),
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "angle-right" })
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value[0].days, (day) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$date(day.date, 'dd')), 1));
                        }), 256))
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, (week, w) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: w,
                            class: "week-calendar__days"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week.days, (day) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(day.classes),
                                    key: day.number
                                }, [
                                    _renderSlot(_ctx.$slots, "day", { day: day }, () => [
                                        _createElementVNode("div", {
                                            class: "week-calendar__day-name",
                                            title: _ctx.$date(day.date)
                                        }, _toDisplayString(day.name), 9, _hoisted_8),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_9, [
                                            _renderSlot(_ctx.$slots, "events", {
                                                events: day.events
                                            }, () => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events, (event, index) => {
                                                    return _renderSlot(_ctx.$slots, "event", { event: event }, () => [
                                                        (event.route)
                                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                                to: { name: event.route.name, params: event.route.params },
                                                                class: _normalizeClass(["week-calendar__event", event.classes]),
                                                                key: index
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(event.title), 1),
                                                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                                                    (event.details)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(event.details), 1))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to", "class"]))
                                                            : (_openBlock(), _createElementBlock("div", {
                                                                class: _normalizeClass(["week-calendar__event", event.classes]),
                                                                key: index,
                                                                onClick: _withModifiers(($event) => (selectEvent(event)), ["prevent"])
                                                            }, [
                                                                _createElementVNode("div", _hoisted_13, _toDisplayString(event.title), 1),
                                                                _cache[4] || (_cache[4] = _createTextVNode()),
                                                                (event.details)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(event.details), 1))
                                                                    : _createCommentVNode("", true)
                                                            ], 10, _hoisted_12))
                                                    ]);
                                                }), 256))
                                            ]),
                                            _cache[5] || (_cache[5] = _createTextVNode()),
                                            (day.events.length === 0)
                                                ? _renderSlot(_ctx.$slots, "no-events", {
                                                    key: 0,
                                                    day: day
                                                })
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ], 2));
                            }), 128))
                        ]));
                    }), 128)),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    (__props.noEventsMessage && visibleEvents.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(__props.noEventsMessage, [_ctx.$date(from.value, from.value.getFullYear() === until.value.getFullYear() ? (from.value.getMonth() === until.value.getMonth() ? 'Do' : 'Do MMMM') : 'Do MMMM YYYY'), _ctx.$date(until.value, 'Do MMMM YYYY')])), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
